// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"6b08f385","313":"96ea1094","322":"697e73cb","422":"8017f441","558":"a778aa8c","574":"4f51eb65","654":"0dfe7bea","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};